<template>
  <div class="padding-five-all">
    <b-container fluid>
      <!-- ================= FILTROS ================= -->
      <b-row>
        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Fecha Inicio</label>
          <b-form-input type="date" v-model="startDate" />
        </b-col>

        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Fecha Fin</label>
          <b-form-input type="date" v-model="endDate" />
        </b-col>

        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Estado</label>
          <b-form-select v-model="estado" :options="estados" />
        </b-col>

        <b-col cols="12" lg="3" class="d-flex align-items-end">
          <b-button variant="dark" class="width-100" @click="buscar">
            Buscar
          </b-button>
        </b-col>
      </b-row>

      <!-- ================= TABLA ================= -->
      <b-row class="mt-3">
        <b-col>
          <b-table
            bordered
            responsive="xl"
            show-empty
            :busy="isBusy"
            :items="items"
            :fields="fields"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle" />
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(desde)="row">
              {{ formatDate(row.item.fechaInicio) }}
            </template>
            <!-- ESTADO -->
            <template #cell(estado)="row">
              <b-badge :variant="badgeEstado(row.item.estado)">
                {{ row.item.estado }}
              </b-badge>
            </template>

            <!-- ACCIONES -->
            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="primary"
                @click="verDetalle(row.item.idLiquidacion)"
              >
                Ver detalle
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "LiquidacionesBackoffice",

  data() {
    return {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      estado: null,
      isBusy: false,
      items: [],

      estados: [
        { value: null, text: "Todos" },
        { value: "PRE_LIQUIDACION", text: "Pre-liquidación" },
        { value: "OBSERVADA", text: "Observada" },
        { value: "RESUELTA", text: "Resuelta" },
      ],

      fields: [
        { key: "idLiquidacion", label: "Liquidación" },
        { key: "idProv", label: "Proveedor" },
        { key: "estado", label: "Estado", class: "text-center" },
        { key: "fechaInicio", label: "Desde" },
        { key: "fechaFin", label: "Hasta" },
        { key: "actions", label: "Acciones", class: "text-center" },
      ],
    };
  },

  computed: {
    ...mapState("module", ["perfil"]),
  },

  mounted() {
    if (this.perfil !== "HP") {
      this.$router.replace("/404");
      return;
    }

    this.buscar();
  },

  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    badgeEstado(estado) {
      return (
        {
          PRE_LIQUIDACION: "primary",
          OBSERVADA: "warning",
          RESUELTA: "success",
        }[estado] || "secondary"
      );
    },

    async buscar() {
      this.isBusy = true;
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_REPORT_VTEX_BASE}/hp/service-system/v1/liquidaciones/backoffice`,
          {
            params: {
              estado: this.estado,
              fechaInicio: this.startDate,
              fechaFin: this.endDate,
            },
          }
        );

        this.items = data || [];
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Error al obtener liquidaciones", {
          variant: "danger",
          solid: true,
        });
      } finally {
        this.isBusy = false;
      }
    },

    verDetalle(id) {
      this.$router.push(`/liquidaciones/backoffice/${id}/detalle`);
    },
  },
};
</script>

<style scoped>
.width-100 {
  width: 100%;
}
</style>
